import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { playlistUpdateTagsAccept, updatePlaylistTags, setPlaylistTags, playlistUpdateTagsDeny, fetchTags, updatePlaylist, deleteTag } from 'signoxe/actions';
import { Box } from 'signoxe/components/layout';
import { Button, Popup } from 'signoxe/components/widgets';
import { getPlaylistUdpateState, getTagsAll } from 'signoxe/selectors';
import './styles.scss';
import Tag from "./Tag";

class TagsPopup extends React.Component {
  static propTypes = {
    TagsState: PropTypes.shape({
      title: PropTypes.string,
      visible: PropTypes.bool.isRequired,
      operation: PropTypes.string,
      resourceType: PropTypes.string,
      id: PropTypes.array.isRequired,
      tags: PropTypes.array.isRequired,

    }).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    fetchTags: PropTypes.func.isRequired,
    allTags: PropTypes.array.isRequired,
    updatePlaylist: PropTypes.func.isRequired,
    updatePlaylistTags: PropTypes.func.isRequired,
    deleteTag: PropTypes.func.isRequired,

  };

  constructor(props) {
    super(props)

    this.state = {
      filteredResults: [],
      selected: null,
      selection: [],
      datta: null,
      searchInput: '',
      searchResults: [],
      showState: false,
      editModeToggled: false,
      showEdit: false,

    }

  }
  handleToggle = () => {
    this.setState({ showState: true }); // tags 
    this.setState({ datta: this.props.allTags }); // tags 
    this.setState({ selected: this.props.TagsState.tags });
    console.log("selected", this.state.selected)


    let yFilter = this.props.TagsState.tags.map(itemY => { return itemY.id; });
    let filteredX = this.props.allTags.filter(itemX => !yFilter.includes(itemX.id));
    this.setState({ filteredResults: filteredX });



  }

  handleCancel = () => {
    this.props.onCancel();
    this.setState({ showState: false });
    this.setState({ datta: null });
    this.setState({ selected: null });
    this.setState({ filteredResults: null });


  }



  handleConfirm = () => {
    const { operation, resourceType, id } = this.props.TagsState;
    var listagsId = this.getFields(this.state.selected, "id");
    var listagsNames = this.getFields(this.state.selected, "name");
    var joinedstring = "[" + listagsNames.join(', ') + "]";

    this.props.updatePlaylistTags(id, listagsNames)
    this.props.updatePlaylist(this.props.TagsState.id.id, { tags: listagsId });
    this.props.onConfirm();
    this.setState({ showState: false });
    this.setState({ datta: null });
    this.setState({ selected: null });
    this.setState({ filteredResults: null });

  }

  searchItems = (searchValue) => {
    this.setState({ searchInput: searchValue })

    if (this.state.searchInput !== '') {
      const filteredData = this.state.filteredResults.filter((item) => {
        return Object.values(item.name).join('').toLowerCase().includes(this.state.searchInput.toLowerCase())
      })
      this.setState({ searchResults: filteredData })
    }
    else {
      this.setState({ searchResults: this.state.filteredResults })
    }
  }


  handleRename = (newName) => {
    this.props.updatePlaylist(this.props.TagsState.id, { tags: ff });
  };



  handleTagAdd = (playlist, tag) =>
    this.props.setPlaylistTags(playlist.id, playlist.maintags.concat(tag))


  handleUpdateToMainData = (tag) => {
    const { selected, datta, selection, filteredResults } = this.state
    const { id } = this.props.TagsState;
    var idObj = selected.find(x => x.id === tag.id);
    this.setState({
      selected: [...this.state.selected].filter((item) => item.id !== tag.id),
    });
    const selectionx = [];
    selectionx.push(idObj)
    // this.handleTagRemove(id, tag.name)
    this.setState({ filteredResults: this.state.filteredResults.concat(idObj) })
    // console.log("selected object", filteredResults)

  }

  handleUpdateToSelection = (tag) => {
    const { id } = this.props.TagsState;
    const { selected, datta, selection, filteredResults } = this.state
    var idObj = datta.find(x => x.id === tag.id);
    this.setState({
      filteredResults: [...this.state.filteredResults].filter((item) => item.id !== tag.id),
    });

    this.setState({
      searchResults: [...this.state.searchResults].filter((item) => item.id !== tag.id),
    });
    var name = tag.name
    var removeQ = name.replace(/["]/g, '')
    // this.handleTagAdd(id, removeQ)

    this.setState({ selected: this.state.selected.concat(idObj) })
    // console.log("selected object", selected)

  }

  handleTagRemove = (playlist, tagToRemove) =>
    this.props.setPlaylistTags(playlist.id, playlist.maintags.filter(tag => tag != tagToRemove))


  removeTag = (tag) => {
    const { operation, resourceType, id } = this.props.TagsState;
    console.log("selected", this.state.selected)
    this.setState({
      selected: [...this.state.selected].filter((item) => item.id !== tag.id),
    });

    this.setState({
      filteredResults: [...this.state.filteredResults].filter((item) => item.id !== tag.id),
    });

    var listagsNames = this.getFields(this.state.selected, "name");
    this.props.updatePlaylistTags(id, listagsNames)
    this.props.deleteTag(tag.id);
  }

  getFields = (input, field) => {
    var output = [];
    for (var i = 0; i < input.length; ++i)
      output.push(input[i][field]);
    return output;
  }

  getAllSelected = () => {
    var ff = this.getFields(this.state.selected, "id");
    console.log("ff", ff)
    console.log("selction arrays", this.state.selected)
  }

  toggleEditMode = () => {
    this.setState({ editModeToggled: !this.state.editModeToggled })
    this.setState({ showEdit: !this.state.showEdit })
  }


  render() {
    const { message, title, visible, tags, } = this.props.TagsState;
    console.log("here", visible)
    const { datta, showState, editModeToggled, showEdit, filteredResults, selected, searchInput, searchResults } = this.state
    const { allTags } = this.props
    if (visible) {
      return (
        <Popup className="confirmation-popup"
          onCancel={this.handleCancel}
          modal>
          <Box direction="column" justifyContent="center">
            <div className='main-header pl-pr'>
              <h5 className='header-tag'> {title} </h5>
              {showEdit === true &&
                <span title="Toggle to Remove tags">
                  <i className={this.state.showEdit ? 'fas fa-toggle-on mr-1' : 'fas fa-toggle-off mr-1'} onClick={this.toggleEditMode}></i>
                </span>
              }


            </div>
            {editModeToggled === false ? <div>
              {showState === true ?
                <div className="tags-box">
                  <div className="tags-box-list">
                    {selected && selected.map(x => {
                      return <Tag buttonText={x.name}
                        isSelected={true}
                        tag={x}
                        onClicked={this.handleUpdateToMainData}
                      />
                    })}
                  </div>
                  <div className='main-header2'>
                    <div>
                      <input className='text-input' type='text' placeholder='search tags' value={searchInput}
                        onChange={(e) => this.searchItems(e.target.value)} />
                    </div>
                    {showEdit === false &&
                      <span title="Toggle to Remove tags">
                        <i className={this.state.showEdit ? 'fas fa-toggle-on mr-1' : 'fas fa-toggle-off mr-1'} onClick={this.toggleEditMode}></i>
                      </span>
                    }

                  </div>
                  <div className="tags-box-list">

                    {filteredResults.filter(tag => {
                      if (searchInput === '') {
                        return filteredResults;
                      } else if (tag.name.toLowerCase().includes(searchInput.toLowerCase())) {
                        return filteredResults;
                      }
                    })
                      .map((tag, index) => (
                        <Tag buttonText={tag.name}
                          tag={tag}
                          onRemove={this.handleUpdateToSelection}
                          isSelected={false}
                        />
                      ))}

                  </div>


                </div>
                :
                <div className="tags-box">
                  <div className="tags-box-list">
                    {tags && tags.map(x => {
                      return <Tag buttonText={x.name}
                        isSelected={true}
                        tag={x}
                        onClicked={this.handleToggle}
                      />
                    })}
                  </div>




                </div>
              }
            </div>
              :
              <div className='edit-tags'>
                {allTags && allTags.map(tag => {
                  return <div className=' edit-tags-border flex flex-jc-sb pl-pr ai-i-c'>
                    <span>
                      {tag.name}
                    </span>
                    <span
                      onClick={() => this.removeTag(tag)}
                    >
                      <i className='fas fa-trash'></i>
                    </span>

                  </div>
                })}
              </div>

            }
            {editModeToggled === false && <Box direction="row" className="actions button-group">
              {showState === true ? <Button className="button-blue" onClick={this.handleConfirm}>Save Changes</Button>
                : <Button className="button-blue" onClick={this.handleToggle}>Update Tags</Button>}
              <Button secondary onClick={this.handleCancel}>Cancel</Button>
            </Box>}
          </Box>
        </Popup >
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  TagsState: getPlaylistUdpateState(state),
  allTags: getTagsAll(state),


});

export default connect(mapStateToProps, {
  onConfirm: playlistUpdateTagsAccept,
  onCancel: playlistUpdateTagsDeny,
  fetchTags,
  updatePlaylist,
  setPlaylistTags,
  updatePlaylistTags,
  deleteTag,
})(TagsPopup);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/TagsPopup/index.js